<apx-chart
  [series]="chartOptions.series"
  [chart]="chartOptions.chart"
  [dataLabels]="chartOptions.dataLabels"
  [plotOptions]="chartOptions.plotOptions"
  [xaxis]="chartOptions.xaxis"
  [colors]="chartOptions.colors"
  [legend]="chartOptions.legend"
></apx-chart>
